import { useState } from 'react';
import { getErrorMessage, showError } from 'shared';
import { assetApi } from '../api';

export const useUploadFile = () => {
  const [isLoading, setIsLoading] = useState(false);

  const urlToFile = async (url: string, filename: string, mimeType: string) => {
    const data = await fetch(url);
    const buffer = await data.arrayBuffer();
    return new File([buffer], filename, { type: mimeType });
  };

  const uploadFile = async (file: File, assetType: string) => {
    if (!file) {
      showError('No file chosen');
      return;
    }
    setIsLoading(true);

    const formData = new FormData();
    formData.append('file', file);
    formData.append('asset_type', assetType);

    try {
      const data = await assetApi.create(formData);
      return data;
    } catch (error) {
      const message = getErrorMessage(
        error,
        `We couldn't upload file. Please try again later`
      );
      showError(message);
    } finally {
      setIsLoading(false);
    }
  };

  const uploadFileWithProgress = async ({
    file,
    onProgressChange,
    assetType
  }: {
    file: File;
    onProgressChange: (progress: number) => void;
    assetType: string;
  }) => {
    if (!file) {
      return;
    }
    setIsLoading(true);
    const formData = new FormData();
    formData.append('file', file);
    formData.append('asset_type', assetType);

    try {
      const data = await assetApi.create(
        formData,
        (e) =>
          e.total && onProgressChange(Math.round((100 * e.loaded) / e.total))
      );
      return data;
    } catch (error) {
      const message = getErrorMessage(
        error,
        `We couldn't upload file. Please try again later`
      );
      showError(message);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    urlToFile,
    uploadFile,
    uploadFileWithProgress,
    isLoading
  };
};
